import { SxProps } from '@mui/material';

export const muiStyles: Record<string, SxProps> = {
  headerRowStyles: {
    '& th': { backgroundColor: '#f5f5f5', borderBottom: 'none' },
    '& th:first-of-type': { borderRadius: '14px 0 0 14px' },
    '& th:last-of-type': { borderRadius: '0 14px 14px 0' },
  },
  chip: {
    '&.MuiChip-root': {
      padding: '4px 8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: { xs: '18px', xl: '22px' },
      borderRadius: '50px',
    },
    '& .MuiChip-label': {
      padding: 0,
    },
  },
  chipLabel: { display: 'flex', alignItems: 'center' },
};
